import { safeSelect } from '../object';
import { getStore } from './store';
import { store } from '../../redux/store.js';

const createSelector = (path, defaultValue = undefined) =>
  (state = store.getState()) => safeSelect(state || getStore().getState(), path) || defaultValue;

export default createSelector;